import {useEffect, useState} from "react";
import {Link, useLocation, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";

const MobileMenuItem = ({item}) => {
  const {iconStyle, title, titleKey, to, condition, titleSecond} = item;
  const {t} = useTranslation();
  const {pathname} = useLocation();
  const [active, setActive] = useState(false);

  useEffect(() => {
    const activeMenu = pathname.split("/")[1];

    if (activeMenu === to) {
      setActive(true);
    } else if (activeMenu === "annonce" && to === "") {
      setActive(true);
    }
  }, [pathname]);

  return (
    <Link
      to={to}
      className={`flex  gap-3  hover:text-[#0F47B3] w-full  justify-start items-center text-xl py-[10px] flex-shrink    ${
        active && (!!condition ? "text-[#0F47B3] " : "text-[#0F47B3] ")
      }`}
    >
      {iconStyle}
      <span
        className={` text-lg font-medium text-center w-auto leading-3 flex  `}
      >
        {titleKey ? t(titleKey) : `${title} ${titleSecond ?? ""}`}
      </span>
    </Link>
  );
};
export default MobileMenuItem;
